/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-25 09:17:44
 * @LastEditors: linxi
 * @LastEditTime: 2023-11-17 10:08:05
 */
import { RecipeStatus } from '../models/recipe'
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface GetRetailListParams {
  current: number
  size?: number
  param?: string
  payMethod: any
  operateUser?: string
  state?: RecipeStatus
  timeHead?: string
  timeTail?: string
}
export interface JuheReturnPremiumParams {
  paymentId: string
}
export function JuheReturnPremium(params: JuheReturnPremiumParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/retailReturnPremium`,
    method: 'POST',
    params,
  }
}
export function getRetailList(params: GetRetailListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/list`,
    method: 'GET',
    params,
  }
}

// 药品零售接口优化
export function getRetailListNew(params: GetRetailListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/retailList`,
    method: 'GET',
    params,
  }
}
// 药品零售-修改患者姓名
export interface editNameFnParams {
  name?: string
  treatmentId?: string
}
export function editNameFn(body: editNameFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/retailPatientChange`,
    method: 'POST',
    body,
  }
}
export interface recipeAdapterMsgParams {
  treatmentId?: any
  id?: any
}
export function getRecipeAdapterMsg(params: recipeAdapterMsgParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/getRecipeAdapterMsg`,
    method: 'POST',
    params,
  }
}

export interface updateTreatmentTypeParams {
  treatmentId?: any
  treatmentType?: any
  reason?: any
}
export function updateTreatmentType(params: updateTreatmentTypeParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/updateTreatmentType`,
    method: 'POST',
    body: params,
  }
}

export interface saveDiseaseParams {
  treatmentId?: any
  registrationId?: any
  disease?: any
}

export function getSaveDisease(params: saveDiseaseParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/updateDisease`,
    method: 'POST',
    body: params,
  }
}

export interface selectDrugTradeSubItemParams {
  timeHead?: any
  timeTail?: any
  groupByDisease?: any
  drugType?: any
}

export function getSelectDrugTradeSubItemList(params: selectDrugTradeSubItemParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/selectDrugTradeSubItemList`,
    method: 'GET',
    params,
  }
}

export function getPatientInsuranceTradeCnt(patientId: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/getPatientInsuranceTradeCnt`,
    method: 'GET',
    params: { patientId },
  }
}

